import router from "@/maintain/router";
import TokenStore from "@/utils/tokenStore";
import Axios from 'axios';
import { Message } from 'element-ui';

const maintainRequest = Axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
});

maintainRequest.interceptors.request.use(
    config => {
        if (TokenStore.getToken('maintain')) {
            config.headers['Authorization'] = 'bearer' + TokenStore.getToken('maintain');
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

maintainRequest.interceptors.response.use(
    response => {
        return response.data;
    },
    error => {
        if (error.response.status === 401) {
            Message({
                message: error.response.data.error_description,
                type: 'warning',
                duration: 3 * 1000
            });
            TokenStore.removeToken('maintain')
            router.push({
                name: "登录",
                query: {redirect: window.location.pathname}
            })
        }
        if (error.response.status === 400) {
            Message({
                message: error.response.data.error_description === '无法获取用户信息' ? "用户名或密码错误" : error.response.data.msg,
                type: 'error',
                duration: 3 * 1000
            });
        }
        if (error.response.status === 502 || error.response.status === 500 || error.response.status === 404) {
            Message({
                message: "服务器出现错误",
                type: 'error',
                duration: 3 * 1000
            });
        }
        return Promise.reject(error)
    }
);

export default maintainRequest;
